// components/Main/Main.js
import React from 'react';
import Home from '../../views/Home/Home';
import Personal from '../../views/Personal/Personal';
import Address from '../../views/Address/Address';
import KYC from '../../views/KYC/KYC';
import Orders from '../../views/Orders/Orders';
import Bank from '../../views/Bank/Bank';
import Payments from '../../views/Payments/Payments';
import './Main.css';

const Main = ({ children, currentView, layoutOpen = true, categoryItems = [], brandItems = [], productItems = [] }) => {
  const baseClasses = 'overflow-x-hidden bg-white transition-all duration-200 w-full max-w-7xl mx-auto min-h-screen shadow-sm';
  const layoutClasses = layoutOpen
    ? 'mt-[calc(7.5rem+env(safe-area-inset-top,0px))] md:mt-20 mb-20 md:mb-0'
    : 'flex ';

  if (children) {
    return (
      <main className={`${baseClasses} ${layoutClasses}`}>
        {children}
      </main>
    );
  }
  const renderView = () => {
    switch (currentView) {
      case 'home':
        return (
          <Home
            categoryItems={categoryItems}
            brandItems={brandItems}
            productItems={productItems}
          />
        );
      case 'personal':
        return <Personal />;
      case 'address':
        return <Address />;
      case 'kyc':
        return <KYC />;
      case 'orders':
        return <Orders />;
      case 'bank':
        return <Bank />;
      case 'payments':
        return <Payments />;
      default:
        return (
          <Home
            categoryItems={categoryItems}
            brandItems={brandItems}
            productItems={productItems}
          />
        );
    }
  };

  return (
    <main className={`${baseClasses} ${layoutClasses}`}>
      {renderView()}
    </main>
  );
};

export default Main;
